export function formatTimestamp(value) {
  const total = Math.max(0, Number(value) || 0);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = (total % 60).toFixed(3).replace(/\.000$/, '');
  const [wholeSeconds, fraction] = seconds.split('.');
  const formattedSeconds = `${wholeSeconds.padStart(2, '0')}${fraction ? `.${fraction}` : ''}`;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${formattedSeconds}`;
}

export function parseTimestamp(value) {
  const parts = String(value || '').trim().split(':');
  if (parts.length < 1 || parts.length > 3 || parts.some((part) => part === '' || !/^\d+(\.\d+)?$/.test(part))) return null;
  const numbers = parts.map(Number);
  const seconds = numbers.pop();
  const minutes = numbers.pop() || 0;
  const hours = numbers.pop() || 0;
  if (seconds >= 60 || minutes >= 60) return null;
  return Number((hours * 3600 + minutes * 60 + seconds).toFixed(3));
}

export function sortPromotions(promotions) {
  return [...promotions].sort((a, b) => Number(a.startSeconds) - Number(b.startSeconds));
}

export function resolveActivePromotion(promotions, currentTime) {
  return sortPromotions(promotions).reduce(
    (active, promotion) => Number(promotion.startSeconds) <= Number(currentTime) ? promotion : active,
    null
  );
}
